import { BlinkColor } from '@ekkogmbh/apisdk';
import { blue, cyan, green, grey, pink, red, yellow } from '@mui/material/colors';
import { Stop } from '@mui/icons-material';
import React, { Component } from 'react';

interface BlinkColorItemProps {
  color: BlinkColor | string;
  saturation?: number;
}

/**
 * Maps ekko colors to MUI colors and generalizes the types for generic access.
 */
const ColorMap: Record<string, Record<number, string>> = {
  [BlinkColor.GREEN]: green,
  [BlinkColor.RED]: red,
  [BlinkColor.BLUE]: blue,
  [BlinkColor.CYAN]: cyan,
  [BlinkColor.MAGENTA]: pink,
  [BlinkColor.WHITE]: grey,
  [BlinkColor.YELLOW]: yellow,
};

/**
 * Maps the color choice to Material-UI color format if possible and applies given saturation values.
 */
export class BlinkColorItem extends Component<BlinkColorItemProps> {
  public getColorCSS(): string {
    const { color } = this.props;
    const saturation = this.props.saturation ?? 400;

    return ColorMap[color] ? ColorMap[color][saturation] : (color as string).toLowerCase();
  }

  /**
   * Ensures proper word form (BLUE -> Blue).
   */
  public getColorName(): string {
    const { color } = this.props;

    return color[0].toUpperCase() + color.slice(1).toLowerCase();
  }

  public render(): React.JSX.Element {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Stop
          style={
            {
              height: 20,
              width: 20,
              marginLeft: 0,
              color: this.getColorCSS(),
              verticalAlign: 'middle',
            } as React.CSSProperties
          }
        />
        {this.getColorName()}
      </div>
    );
  }
}
